import styled from '../../../../../styles/styledComponents/themeComponents';
import 'react-virtualized/styles.css';

export const VirtualizedTableWrapperStyle = styled.div<{ minWidth?: number }>`
  min-width: ${(props): string => (props.minWidth ? `${props.minWidth}px` : 'none')};
  .virtualized-table {
    overflow-x: scroll;

    .ReactVirtualized__Table__headerRow {
      border: 1px solid #e8e8e8;

      .ReactVirtualized__Table__headerColumn {
        background: #fafafa;
        border-right: 1px solid #e8e8e8;

        &:last-of-type {
          border-right: 0;
        }
      }
    }

    .ReactVirtualized__Table__row {
      border-bottom: 1px solid #e8e8e8;
      border-right: 1px solid #e8e8e8;
      border-left: 1px solid #e8e8e8;

      .ReactVirtualized__Table__rowColumn {
        border-right: 1px solid #e8e8e8;

        &:last-of-type {
          border-right: 0;
        }
      }
    }

    .ReactVirtualized__Table__headerColumn,
    .ReactVirtualized__Table__rowColumn {
      margin: 0;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &.empty {
      .ReactVirtualized__Table__headerRow,
      .ReactVirtualized__Table__Grid {
        width: 100% !important;
      }

      .ant-empty-normal {
        margin-top: 200px;
      }
    }
  }
`;
export const HeaderStyle = styled.div`
  text-align: center;
`;

export const CellContentStyle = styled.div`
  display: flex;
  flex-flow: column;
  text-align: center;
  padding: 12px 8px;
`;
